<template>
  <div class="fadeIn">
    <div class="ra-auth--form__header">
      <h1>Welcome</h1>
      <p>Provide required information to create an account.</p>
    </div>
    <div class="ra-auth--form__form">
      <el-form :model="form" label-position="top" ref="form">
        <el-row type="flex" class="flex-wrap" :gutter="20">
          <el-col :md="12">
            <el-form-item
              label="First Name"
              prop="first_name"
              :rules="validateField('First Name')"
            >
              <el-input type="text" v-model="form.first_name" />
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item
              label="Last Name"
              prop="last_name"
              :rules="validateField('Last name')"
            >
              <el-input type="text" v-model="form.last_name" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="flex-wrap">
          <el-col :span="24">
            <el-form-item
              label="Email"
              prop="email"
              :rules="validateEmail('Email')"
            >
              <el-input type="email" v-model="form.email" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="flex-wrap">
          <el-col :span="24">
            <el-form-item
              label="Organisation Name (optional)"
              prop="organisation_name"
            >
              <el-input type="text" v-model="form.organisation_name" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="ra-auth--form__actions">
      <el-button :loading="loading" type="primary" @click="register"
        >Register</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "Register",
  data() {
    return {
      loading: false,
      form: {
        first_name: "",
        last_name: "",
        email: "",
        organisation_name: ""
      }
    };
  },
  methods: {
    register() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return false;
        }
        this.loading = true;
        this.$http
          .post("accounts/users", {
            body: this.form,
            method: "POST"
          })
          .then(response => {
            const resData = response.data;
            if (resData.status === "error") {
              this.loading = false;
              this.handleErrors(resData);
              this.gaTrack("Failed", this.form.email);
            } else {
              this.notification(
                "Registration successful",
                "An OTP has been sent to your email for verification",
                "success"
              );
              sessionStorage.setItem(
                "radius-verification-data",
                JSON.stringify({
                  token: resData.otp && resData.otp.token,
                  email: this.form.email
                })
              );
              this.$router.push({ name: "verify-otp" });

              this.gaTrack("Successful", this.form.identifier);
            }
          })
          .catch(() => {
            this.loading = false;
            this.notification("Error", "An unknown error occurred", "danger");
          });
      });
    },

    gaTrack(type, identifier) {
      this.$ga.event({
        eventCategory: "Signup",
        eventAction: type,
        eventLabel: identifier
      });
    }
  },
  created() {
    this.$ga.page({
      page: "/register",
      title: "Signup",
      location: window.location.href
    });
  }
};
</script>
